var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncomeChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333313,
    width: 3.42857,
    height: 24,
    rx: 1.71428,
    fill: "#34c38f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.19025,
    y: 6.54553,
    width: 3.42857,
    height: 17.4545,
    rx: 1.71428,
    fill: "#34c38f",
    fillOpacity: 0.43
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0477,
    y: 16.3636,
    width: 3.42857,
    height: 7.63636,
    rx: 1.71428,
    fill: "#34c38f"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9046,
    y: 3.27271,
    width: 3.42857,
    height: 20.7273,
    rx: 1.71428,
    fill: "#34c38f",
    fillOpacity: 0.78
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeChart);
export default __webpack_public_path__ + "static/media/incomeChart.5be5fcb9f1dd2e2f4e0b7ab436e09566.svg";
export { ForwardRef as ReactComponent };